/* Services */
import {
  accountsAPI,
} from '@/services';

export default {
  async GET_ASSIGNEES({ commit }, filters) {
    await accountsAPI
      .getAssignees(filters)
      .then(({ data: response }) => {
        commit('SET_ASSIGNEES', response.data);
      })
      .catch(() => {
        // silent error
      });
  },
};
